import React from 'react';
import { connect } from 'react-redux';
import { fetchChefs } from '../../actions';
import SocialButtons from './SocialButtons';

class Chefs extends React.Component {
  componentDidMount() {
    this.props.fetchChefs();
  }

  render() {
    const {chefs} = this.props;
    return (
      <div className="container">
        <div className="row">
          {chefs.map((chef, index) => {return <div key={index} className="col-md-3 col-sm-6 thumbnailCenter">
                                          <div className="thumbnail">
                                            <img src={`https://s3-eu-west-1.amazonaws.com/recetix/chefs/300x300/${chef.chefId}.png`} alt={chef.name} />
                                            <div className="caption">
                                            <h4><a href={chef.blog}>{chef.name}</a></h4>
                                            {<SocialButtons urls={chef} />}
                                            </div>
                                          </div>
                                        </div>
        })}
        </div>
      </div>
    );
  }
}

Chefs.propTypes = {
  // chefs: React.PropTypes.array.isRequired,
  // fetchChefs: React.PropTypes.func.isRequired,
}

function mapStateToProps(state) {
  return {
    chefs: state.chefs
  }
}

export default connect(mapStateToProps, { fetchChefs })(Chefs);



// WEBPACK FOOTER //
// ./src/components/Chefs/index.js